export default __webpack_public_path__ + "static/media/image4-8.6af2b7dc.png";